import React from "react";
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Hidden from "@material-ui/core/Hidden";
import Poppers from "@material-ui/core/Popper";
// @material-ui/icons
import Icon from "@material-ui/core/Icon";
import Menu from "@material-ui/core/Menu";
import Badge from "@material-ui/core/Badge";
import Person from "@material-ui/icons/Person";
import Notifications from "@material-ui/icons/Notifications";
// import Dashboard from "@material-ui/icons/Dashboard";
// import Search from "@material-ui/icons/Search";
// core components
// import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import axios from "axios";
import conf from "../../conf.json";

import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";

class HeaderLinks extends React.Component {
  state = {
    open: false,
    openprofile: false,
    anchorEl: null,
    anchorElProfile: null,
    dataNotification: [],
    countNotification:0
  };
  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClickProfile = event => {
    this.setState({ anchorElProfile: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleCloseProfile = () => {
    this.setState({ anchorElProfile: null });
  };
  logout = event => {
    // if (this.anchorEl2.contains(event.target)) {
    //   return;
    // }
    this.setState({ anchorElProfile: null });
    localStorage.clear("token");
    localStorage.clear("data");
    window.location.assign("/");
  };

  getNotification() {
    const params = {
      token: localStorage.getItem("token")
    };
    axios
      .post(conf.url + "/notification/get", params, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        let count  = 0;
        res.data.data.map(data=>{
          if(data.read_status === 0)
            count++
        })
        this.setState({
          dataNotification: res.data.data,
          countNotification:count
        });
      });
  }
  constructor(props) {
    super(props);
  
    this.readNotification = this.readNotification.bind(this)
    this.getNotification = this.getNotification.bind(this)
    //setInterval(this.getNotification, 15000);
  }
  componentDidMount(){
    this.getNotification();
  }
  readNotification(id){
    const params = {
      id:id,
      token: localStorage.getItem("token")
    };
    axios
      .put(conf.url + "/notification", params, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        this.state.dataNotification.map(data=>{
          if(data.id === id){
            localStorage.setItem("ct_id",data.ct_id);
            window.location.assign("/tables");
          }
        })
       // this.getNotification();
      });
   
    this.handleClose();
  }

  render() {
    const { classes } = this.props;
    const { anchorEl, anchorElProfile } = this.state;
    let notifications = [];
    if(this.state.dataNotification.length == 0){
      notifications.push(<div className="mt-auto mb-auto p-2">
      ไม่มีแจ้งเตือน
      </div>)
    }
    for (let i = 0; i < (this.state.dataNotification.length > 10 ? 10 : this.state.dataNotification.length); i++) {
      notifications.push(
        <MenuItem key={this.state.dataNotification[i].id} onClick={()=>this.readNotification(this.state.dataNotification[i].id)} className={classes.dropdownItem}>
          <div className="mt-auto mb-auto">
            {this.state.dataNotification[i].read_status === 0 ? (
              <Icon
                style={{
                  paddingTop: "2px",
                  marginRight: "4px",
                  color: "red"
                }}
              >
                error
              </Icon>
            ) : (
              <Icon
                style={{
                  paddingTop: "2px",
                  marginRight: "4px",
                  color: "green"
                }}
              >
                check_circle
              </Icon>
            )}

            <span dangerouslySetInnerHTML={{__html: this.state.dataNotification[i].text.replace(/(?:\r\n|\r|\n)/g, '<br />')}} />
          </div>
        </MenuItem>
      );
    }
    if(this.state.dataNotification.length > 6){
      notifications.push(
        <MenuItem key={9999999} onClick={()=>window.location.assign("/notification")} className={classes.dropdownItem}>
          <div className="mt-auto mb-auto">
            <span>ดูทั้งหมด</span>
          </div>
        </MenuItem>
      );
    }
    return (
      <div className="row">
        <div className="mr-3">
          <Badge
            className={classes.margin}
            badgeContent={this.state.countNotification}
            color="secondary"
          >
            <Notifications onClick={this.handleClick} />
          </Badge>

          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
          >
            {notifications}
          </Menu>
        </div>

        <div className="mr-5">
          <Icon onClick={this.handleClickProfile}>person</Icon>
          <Menu
            id="simple-menu"
            anchorEl={anchorElProfile}
            open={Boolean(anchorElProfile)}
            onClose={this.handleCloseProfile}
          >
            <a href="userprofile">
              <MenuItem onClick={this.handleCloseProfile}>Profile</MenuItem>
            </a>
            <MenuItem onClick={this.logout}>Logout</MenuItem>
          </Menu>
        </div>
      </div>
    );
  }
}

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx